import { CheckoutState } from '../context/checkout.context';
import { testId } from '../utils';
import { Typography } from './primitives';
import * as RadAccordion from '@radix-ui/react-accordion';
import clsx from 'clsx';
import { ReactNode } from 'react';

export type AccordionItem = {
  title: ReactNode;
  content: ReactNode;
  active?: boolean;
  showIcon?: boolean;
  value: string;
};
type AccordionProps = {
  items: AccordionItem[];
  'data-testid': string;
  selectedValue: CheckoutState;
  handleSelectedValueChange: (value: CheckoutState) => void;
};

export const CheckoutAccordion = ({
  selectedValue,
  handleSelectedValueChange,
  items,
  'data-testid': dataTestId,
}: AccordionProps) => {
  return (
    <RadAccordion.Root
      className="w-full min-w-96 md:rounded-md md:shadow-md bg-white"
      type="single"
      collapsible
      value={selectedValue}
      onValueChange={handleSelectedValueChange}
    >
      {items.map((item: AccordionItem, i: number) => (
        <RadAccordion.Item
          value={item.value}
          className="border-b"
          key={item.value}
          {...testId(dataTestId, 'item-' + item.value)}
          disabled={!item.active}
        >
          <RadAccordion.Header className="flex flex-col p-4">
            <RadAccordion.Trigger className="bg-white flex justify-between transition-all group">
              <span>
                {!!item.showIcon && (
                  <span
                    {...testId(dataTestId, 'icon')}
                    className="text-base material-symbols-outlined text-green-dark px-1"
                  >
                    check_circle
                  </span>
                )}
                <Typography
                  variant="title-small"
                  className={clsx(item.active ? 'text-black' : 'text-gray')}
                >
                  {item.title}
                </Typography>
              </span>
              <span
                className={clsx(
                  item.active ? 'text-gray-dark' : 'text-gray',
                  'material-symbols-outlined transition-transform duration-500 ease-in-out group-data-[state=open]:rotate-180',
                )}
              >
                expand_less
              </span>
            </RadAccordion.Trigger>
            <RadAccordion.Content
              forceMount
              className="data-[state=closed]:hidden"
            >
              {item.content}
            </RadAccordion.Content>
          </RadAccordion.Header>
        </RadAccordion.Item>
      ))}
    </RadAccordion.Root>
  );
};
CheckoutAccordion.displayName = 'CheckoutAccordion';
